import { render, staticRenderFns } from "./SpeedChooser.vue?vue&type=template&id=15e4652c&scoped=true"
import script from "./SpeedChooser.vue?vue&type=script&lang=js"
export * from "./SpeedChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4652c",
  null
  
)

export default component.exports